import React from 'react';
import './SyncTemplateGraphic.css';

const SystemBox = ({ imageUrl, companyName, systemName, label }) => (
    <div className="stg-system-box">
        {imageUrl ? (
            <img className="stg-logo" src={imageUrl} alt={companyName || systemName} />
        ) : (
            <div className="stg-logo-placeholder" />
        )}
        <div className="stg-system-label">{label}</div>
        <div className="stg-system-name">{systemName || '—'}</div>
    </div>
);

const SyncTemplateGraphic = ({ template, compact = false }) => {
    const hasGraphic = template.sourceSystemName || template.targetSystemName;

    if (!hasGraphic) return null;

    return (
        <div className={`stg-graphic ${compact ? 'stg-compact' : ''}`}>
            <SystemBox
                imageUrl={template.sourceImageUrl}
                companyName={template.sourceCompanyName}
                systemName={template.sourceSystemName}
                label="SOURCE"
            />
            <div className="stg-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            <SystemBox
                imageUrl={template.targetImageUrl}
                companyName={template.targetCompanyName}
                systemName={template.targetSystemName}
                label="TARGET"
            />
        </div>
    );
};

export default SyncTemplateGraphic;
